import styled from '@emotion/styled'

import { ShiftHours } from '@bemlo/enums'
import { OnCallTime } from '@bemlo/schedule'

import { Color } from '../../../../constants'
import { Text } from '../../../../elements'
import { byCellFilter } from '../by-filter'
import { Cell } from '../components/Cell'
import { Row } from '../components/Row'
import { VacanciesTitle } from '../components/VacanciesTitle'
import { useSchedule } from '../useSchedule'

const Wrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  margin: 'auto',
  fontWeight: 500,
  color: Color.CHARCOAL,
})

const getColor = (booked: number, min: number, max: number) => {
  if (booked > max) {
    return Color.LIGHT_YELLOW
  }
  if (booked >= min) {
    return Color.LIGHT_GREEN
  }
  return Color.LIGHT_RED
}

type ShiftDemandsProps = {
  title?: string
  shiftHours: ShiftHours
  startTime: string
  endTime: string
  breakTime: number
  comment: string
  onCallTime: OnCallTime | null | undefined
  tags?: { id: string }[]
  scheduleResourceId: string
  showBreakBadge: boolean
  demands: { date: string; min: number; max: number }[]
}

export const ShiftDemands = (props: ShiftDemandsProps) => {
  const { startDate, days, shifts: allShifts, isScrolled, zoom } = useSchedule()

  const shifts = allShifts.filter(byCellFilter(props))

  return (
    <Row>
      <Cell isTitle rowSpan={1} rightShadow={isScrolled}>
        <VacanciesTitle
          {...props}
          shiftHours={props.shiftHours}
          startDate={startDate}
          persisted={false}
          shiftIds={[]}
        />
      </Cell>
      {days.map((day) => {
        const shiftsOnDay = shifts.filter((shift) => shift.date === day.dateISO)
        const shiftsFilled = shiftsOnDay.filter(
          (s) => s.bookedCandidateId || typeof s.rowKey === 'number',
        ).length
        const { min, max } = props.demands.find(
          (d) => d.date === day.dateISO,
        ) || { min: 0, max: 0 }

        return (
          <Cell
            key={day.dateISO}
            disabled={!day.withinRange}
            weekend={day.isWeekend}
            backgroundColor={getColor(shiftsFilled, min, max)}
          >
            <Wrapper>
              <Text fontWeight={600}>{shiftsFilled}</Text>
              {zoom !== 'month' && (
                <Text fontWeight={400}>
                  <em>({min === max ? min : `${min} - ${max}`})</em>
                </Text>
              )}
            </Wrapper>
          </Cell>
        )
      })}
    </Row>
  )
}
